'use client';

import { Label } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import { useTheme } from 'next-themes';
import { Switch } from '../../../../Switch/Switch';

function Darkmode() {
  const { setTheme, resolvedTheme } = useTheme();
  const t = useTranslations('my_account');

  const handleToggleDarkMode = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light');
  };

  return (
    <div
      className="flex items-center justify-between gap-4 px-4 py-5 border border-border rounded-lg"
      data-testid="theme-section"
      data-theme={resolvedTheme ?? 'dark'}
      data-track-section="Visual"
    >
      <div className="space-y-1">
        <Label htmlFor="dark-mode-switch" className="paragraph-strong">
          {t('darkMode')}
        </Label>
      </div>
      <Switch
        id="dark-mode-switch"
        data-testid="dark-mode-switch"
        checked={resolvedTheme === 'dark'}
        data-track-name="Mode"
        data-track-value={resolvedTheme}
        onCheckedChange={handleToggleDarkMode}
        aria-label="Toggle dark mode"
      />
    </div>
  );
}

export { Darkmode };
